import { RGB } from '@app/model/rgb.model';

export const getFontColorOfBoxByRGBvalue = (rgbColor: RGB) => {
    return rgbColor.red * 0.299 + rgbColor.green * 0.587 + rgbColor.blue * 0.114 > 186 ? '#000' : '#fff';
};

export const base64toBlob = (base64str: string) => {
    const byteCharacters = atob(base64str);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray]);
};
